// Tiny Web Audio API beep — used by the checkout countdowns so the
// front desk hears an audible cue at 30 / 25 / 20 / 15 / 10 / 5 / 0
// minutes before a guest is due to leave.  No audio file needed.
//
// Browsers require a user gesture before audio is allowed.  Once the
// operator has clicked anywhere in the page, beeps will play.  Failures
// (e.g. autoplay-blocked, AudioContext unavailable) are swallowed so the
// countdown logic keeps working in silence rather than throwing.

let _audioCtx = null;

function getCtx() {
  if (_audioCtx) return _audioCtx;
  try {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    _audioCtx = new Ctor();
    return _audioCtx;
  } catch (_) {
    return null;
  }
}

/**
 * Play a short tone.
 *   beep({ durationMs: 220, frequency: 880, volume: 0.18 });
 * Returns true on success, false if audio is unavailable.
 */
export function beep({ durationMs = 220, frequency = 880, volume = 0.18 } = {}) {
  const ctx = getCtx();
  if (!ctx) return false;
  try {
    // Resume if the browser had suspended the context (common until
    // there's been a user gesture).
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = frequency;
    // Quick fade in/out to avoid speaker pop.
    const now = ctx.currentTime;
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(volume, now + 0.01);
    gain.gain.linearRampToValueAtTime(0, now + durationMs / 1000);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + durationMs / 1000 + 0.02);
    return true;
  } catch (_) {
    return false;
  }
}

/** A two-tone "ding-dong" alert used at the final checkout deadline. */
export function alertChime() {
  beep({ durationMs: 220, frequency: 880 });
  setTimeout(() => beep({ durationMs: 260, frequency: 660 }), 240);
}
